import { useCallback } from 'react';
import { MBSentry } from '@shared/util/sentry';

const DEBUG_ANALYTICS = import.meta.env.VITE_DEBUG_ANALYTICS;

/*
    Analytics wrapper for Segment on the frontend.
    This is taken from frontend/web/src/core/Segment.js
*/
export const MBAnalytics = {
  identify(userId: number, properties: Dict<string | boolean | number>) {
    if (DEBUG_ANALYTICS) {
      console.warn(['MBAnalytics.identify'], userId, properties);
    }

    if (import.meta.env.DEV) {
      return;
    }

    if (!!window['analytics']) {
      window['analytics'].identify(userId, properties);
    }
  },

  track(eventName: string, eventProperties: Dict<string | boolean | number> = {}) {
    // For compatibility with older events, we suffix all events
    const eventNameWithPrefix = `MyBiz::Web::${eventName}`;
    const eventPropertiesWithDefault = {
      path: window.location.pathname,
      ...eventProperties,
    };

    if (DEBUG_ANALYTICS) {
      console.warn('[MBAnalytics]', eventNameWithPrefix, eventPropertiesWithDefault);
    }

    MBSentry.breadcrumb({
      message: eventName,
      category: 'analytics',
      data: eventProperties,
    });

    if (import.meta.env.DEV) {
      return;
    }

    if (!!window['analytics']) {
      window['analytics'].track(eventNameWithPrefix, eventPropertiesWithDefault);
    }
  },

  screen(_eventName: string, _eventProperties: Dict<string | boolean | number> = {}) {
    throw new Error('TODO(fant): implement screen tracking on web');
  },

  reset() {
    if (!!window['analytics']) {
      window['analytics'].reset();
    }
  },
};

export function useTrackEvent(eventName: string): () => void {
  return useCallback(() => MBAnalytics.track(eventName), [eventName]);
}
